var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataScience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#E7EBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6909 23.6898C25.3018 22.0789 23.1649 17.3302 18.9179 13.0832C14.671 8.83625 9.92226 6.69932 8.31135 8.31024C6.70043 9.92115 8.83737 14.6699 13.0843 18.9168C17.3313 23.1638 22.08 25.3007 23.6909 23.6898Z",
    stroke: "#333091",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9179 18.9168C23.1649 14.6698 25.3018 9.9211 23.6909 8.31019C22.08 6.69928 17.3313 8.83621 13.0843 13.0832C8.83737 17.3301 6.70043 22.0789 8.31135 23.6898C9.92226 25.3007 14.671 23.1637 18.9179 18.9168Z",
    stroke: "#333091",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.125C16.6213 17.125 17.125 16.6213 17.125 16C17.125 15.3787 16.6213 14.875 16 14.875C15.3787 14.875 14.875 15.3787 14.875 16C14.875 16.6213 15.3787 17.125 16 17.125Z",
    fill: "#333091"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScience);
export default __webpack_public_path__ + "static/media/data-science.74dc69414026aa0b1ee8dbf58c2d7067.svg";
export { ForwardRef as ReactComponent };